export const getAreaList = (store) => store.area.data;

export const getPaginationInfo = (store) => {
  const { data, ...rest } = store.area;
  return rest;
};
